import React, { useState } from 'react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ContactModal from '../components/contact-modal'
import './cases.css'

const Cases = (props) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  const caseStudies = [
    {
      id: 'wewatch-security',
      title: 'WeWatch Security',
      subtitle: 'Employer Branding & Social Recruiting für Sicherheitsunternehmen',
      industry: 'Sicherheitsdienst',
      location: 'Berlin & Bundesweit',
      image: '/cases/wewatch-security.jpg',
      challenge: 'Als wachsendes Sicherheitsunternehmen mit über 500 Mitarbeitenden stand WeWatch Security vor der Herausforderung, qualifiziertes Personal in einem hart umkämpften Markt zu gewinnen. Die Branche kämpft oft mit Vorurteilen und benötigt eine professionelle Positionierung als attraktiver Arbeitgeber.',
      strategy: 'Entwicklung einer ganzheitlichen Social-Media-Strategie mit Fokus auf authentische Mitarbeiterporträts, Behind-the-Scenes Content und gezielten Recruiting-Kampagnen auf Facebook, Instagram und LinkedIn.',
      results: [
        'Messbare Steigerung der Bewerbungen',
        'Positive Arbeitgeberwahrnehmung',
        'Schnelle Reaktionszeiten im Community Management'
      ]
    },
    {
      id: 'slr-gruppe',
      title: 'SLR Gruppe',
      subtitle: 'Social Media Recruiting für führende Eisengießerei',
      industry: 'Industrie & Produktion',
      location: 'Deutschland',
      image: '/cases/slr-steel.webp',
      challenge: 'Die SLR Gruppe als eine der führenden Eisengießereien für Sphäroguss suchte nach neuen Wegen, Fachkräfte wie Verfahrensmechaniker und Gießereimechaniker zu gewinnen. Klassische Stellenanzeigen erreichten die Zielgruppe kaum noch.',
      strategy: 'Aufbau einer Karriereseite, Instagram-Recruiting-Kanal mit authentischen Einblicken in den Arbeitsalltag, Content-Produktion vor Ort und gezielte Recruiting-Kampagnen.',
      results: [
        'Qualifizierte Bewerber gewonnen',
        'Hohe Interaktionsraten',
        'Gesteigerte Mitarbeiteridentifikation'
      ]
    },
    {
      id: 'dare-entsorgung',
      title: 'DARE GmbH',
      subtitle: 'Instagram Recruiting für Entsorgungsfachbetrieb',
      industry: 'Entsorgung & Recycling',
      location: 'Berlin & Brandenburg',
      image: '/cases/dare-mitarbeiter.webp',
      challenge: 'DARE als etablierter Entsorgungsfachbetrieb benötigte neue LKW-Fahrer, Disponenten und Fachkräfte. Die Herausforderung: Die Zielgruppe ist nicht auf klassischen Jobportalen, sondern auf Social Media unterwegs.',
      strategy: 'Neukonzeption der Karriereseite, Aufbau eines Instagram-Karrierekanals mit Mitarbeiter-Features und Day-in-the-Life Content, kombiniert mit gezielten Recruiting Ads.',
      results: [
        'Erfolgreiche Stellenbesetzungen',
        'Authentische Arbeitgebermarke',
        'Starke Social Media Präsenz'
      ]
    },
    {
      id: 'catella-finance',
      title: 'CATELLA',
      subtitle: 'LinkedIn Recruiting für Corporate Finance',
      industry: 'Finance & Immobilien',
      location: 'Europa',
      image: '/cases/catella-mitarbeiter.webp',
      challenge: 'Als spezialisierter Anbieter im Immobilieninvestmentbereich suchte Catella hochqualifizierte Fachkräfte im Bereich Asset Management und Corporate Finance. Der Wettbewerb um diese Talente ist besonders intensiv.',
      strategy: 'Entwicklung einer LinkedIn-fokussierten Employer Branding Strategie mit professionellem Content, Thought Leadership Positionierung und gezielten Recruiting-Kampagnen für Finanzexperten.',
      results: [
        'Steigerung der Markenbekanntheit',
        'Qualifizierte Bewerbungen',
        'Verbesserte Mitarbeiterbindung'
      ]
    },
    {
      id: 'siltec-allgaeu',
      title: 'Siltec',
      subtitle: 'Social Recruiting im Allgäu für B2B Industriebetrieb',
      industry: 'Silikon-Technik',
      location: 'Allgäu',
      image: '/cases/siltec-ausbildung.webp',
      challenge: 'Siltec, spezialisiert auf Silikon-Komponenten für Medizintechnik und Industrie, suchte in der ländlichen Region Allgäu nach Fachkräften und Auszubildenden. Die Konkurrenz durch größere Arbeitgeber in Städten war groß.',
      strategy: 'Employer Branding Strategie mit regionalem Fokus, Optimierung der Karriereseite, Social Recruiting Ads mit Betonung der Lebensqualität im Allgäu und Active Recruiting.',
      results: [
        'Attraktiver Arbeitgeber im Allgäu',
        'Erhöhter Traffic auf Karriereseite',
        'Erfolgreiche Neueinstellungen'
      ]
    }
  ]

  return (
    <div className="cases-container">
      <Helmet>
        <title>Social Recruiting Cases & Erfolgsgeschichten | Referenzen</title>
        <meta name="description" content="Entdecken Sie unsere erfolgreichen Social Recruiting Kampagnen: Echte Case Studies aus verschiedenen Branchen mit messbaren Ergebnissen." />
        <meta property="og:title" content="Social Recruiting Cases & Erfolgsgeschichten" />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>
      
      <section className="cases-hero">
        <div className="cases-hero-content">
          <h1 className="cases-hero-title">
            Unsere Social Recruiting Erfolgsgeschichten
          </h1>
          <p className="cases-hero-description">
            Entdecken Sie, wie wir Unternehmen dabei geholfen haben, durch strategisches Social Media Recruiting 
            qualifizierte Fachkräfte zu gewinnen. Echte Cases, echte Ergebnisse.
          </p>
        </div>
      </section>

      {/* Trust Logos Section */}
      <section className="cases-trust">
        <div className="cases-trust-container">
          <p className="cases-trust-label">Vertrauen von führenden Unternehmen</p>
          <div className="cases-trust-logos">
            <img src="/wewatch.webp" alt="WeWatch Security" className="cases-trust-logo" />
            <img src="/adac.webp" alt="ADAC" className="cases-trust-logo" />
            <img src="/captrain.webp" alt="Captrain" className="cases-trust-logo" />
            <img src="/hanse.webp" alt="Hanse" className="cases-trust-logo" />
            <img src="/cases/catella-logo.webp" alt="Catella" className="cases-trust-logo" />
          </div>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="cases-grid-section">
        <div className="cases-grid-container">
          <h2 className="cases-grid-title">Unsere Case Studies</h2>
          <div className="cases-grid">
            {caseStudies.map((caseStudy, index) => (
              <article key={caseStudy.id} className="case-card">
                <div className="case-card-image-container">
                  <img 
                    src={caseStudy.image} 
                    alt={caseStudy.title} 
                    className="case-card-image"
                  />
                  <div className="case-card-badges">
                    <span className="case-card-badge">{caseStudy.industry}</span>
                    <span className="case-card-badge">{caseStudy.location}</span>
                  </div>
                </div>
                <div className="case-card-content">
                  <h3 className="case-card-title">{caseStudy.title}</h3>
                  <p className="case-card-subtitle">{caseStudy.subtitle}</p>
                  
                  <div className="case-card-section">
                    <h4>Herausforderung</h4>
                    <p>{caseStudy.challenge}</p>
                  </div>
                  
                  <div className="case-card-section">
                    <h4>Strategie</h4>
                    <p>{caseStudy.strategy}</p>
                  </div>
                  
                  <div className="case-card-section">
                    <h4>Ergebnisse</h4>
                    <ul className="case-card-results">
                      {caseStudy.results.map((result, idx) => (
                        <li key={idx}>✓ {result}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Key Learnings Section */}
      <section className="cases-learnings">
        <div className="cases-learnings-container">
          <h2 className="cases-learnings-title">Was diese Cases zeigen</h2>
          <div className="cases-learnings-grid">
            <div className="cases-learning-card">
              <div className="cases-learning-icon">🎯</div>
              <h3>Zielgruppengerechte Ansprache</h3>
              <p>Jede Branche und Zielgruppe erfordert eine individuelle Strategie. Von Instagram für Young Professionals bis LinkedIn für Führungskräfte.</p>
            </div>
            <div className="cases-learning-card">
              <div className="cases-learning-icon">📱</div>
              <h3>Multi-Channel Ansatz</h3>
              <p>Die Kombination aus organischem Content, Community Management und gezielten Ads maximiert die Reichweite und Qualität der Bewerbungen.</p>
            </div>
            <div className="cases-learning-card">
              <div className="cases-learning-icon">🏆</div>
              <h3>Authentizität gewinnt</h3>
              <p>Echte Mitarbeitergeschichten und authentische Einblicke in den Arbeitsalltag überzeugen mehr als jede Hochglanz-Kampagne.</p>
            </div>
            <div className="cases-learning-card">
              <div className="cases-learning-icon">📈</div>
              <h3>Messbare Ergebnisse</h3>
              <p>Von der Steigerung der Bewerberzahlen bis zur Verbesserung der Arbeitgebermarke – Social Recruiting liefert konkrete KPIs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cases-cta">
        <div className="cases-cta-container">
          <h2 className="cases-cta-title">
            Bereit für Ihre eigene Erfolgsgeschichte?
          </h2>
          <p className="cases-cta-description">
            Lassen Sie uns gemeinsam Ihre Social Recruiting Strategie entwickeln und qualifizierte 
            Talente für Ihr Unternehmen gewinnen.
          </p>
          <div className="cases-cta-buttons">
            <button 
              className="cases-cta-button cases-cta-primary"
              onClick={() => openContactModal('Case Studies - Beratung anfragen')}
            >
              Kostenlose Beratung anfragen
            </button>
            <button 
              className="cases-cta-button cases-cta-secondary"
              onClick={() => openContactModal('Case Studies - Strategie-Call')}
            >
              Strategie-Call vereinbaren
            </button>
          </div>
        </div>
      </section>

      <Footer activePage="cases" />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default Cases
